/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React, { useEffect, useMemo, useState } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import api from "../../services/AuthApi"
import UpdateUserAccount from "./UpdateUserAccount"
import DeleteModal from "./DeleteModal"
import {
  Box,
  IconButton,
  Tooltip,
  Paper,
  InputBase,
  Stack,
  Fab,
} from "@mui/material"
import { Delete, Edit, Lock, LockOpen } from "@mui/icons-material"
import UserLockModal from "./UserLockModal"
import UserUnlockModel from "./UserUnlockModel"
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling"
import Alerts from "../../errorHandeling/Alerts"
import SearchIcon from "@mui/icons-material/Search"
import RestartAltIcon from "@mui/icons-material/RestartAlt"

const ApproveTable = ({ isUpdate, setIsUpdate }) => {
  // data and fetching state
  const [appData, setAppData] = useState([])
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isAppRefetching, setIsAppRefetching] = useState(false)
  const [appRowCount, setAppRowCount] = useState(0)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [lockModalOpen, setLockModalOpen] = useState(false)
  const [unlockModalOpen, setUnlockModalOpen] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [searchInput, setSearchInput] = useState()

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  //modals state
  const [updateModalOpen, setUpdateModalOpen] = useState(false)
  const [rowData, setRowData] = useState([])

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  // Data loadingcto table
  let alertProps = {}
  if (isError) {
    alertProps = {
      color: "error",
      children: "Error loading data",
    }
  }

  let getAppConfig = {
    headers: {
      "Sort-Order": "ASC",
      Action: "VAU",
    },
  }

  const fetchData = () => {
    api
      .get(
        "/users/" +
          pagination.pageIndex +
          "/" +
          pagination.pageSize +
          "/userId",
        getAppConfig
      )
      .then((res) => {
        setAppData(res.data?.dataList)
        setAppRowCount(res.data?.total)
        setIsLoading(false)
      })
      .catch((error) => {
        console.log(error)
      })

    setIsError(false)
    setIsAppRefetching(false)
  }

  useEffect(() => {
    fetchData()
  }, [pagination.pageIndex, pagination.pageSize, isUpdate, isUnauhtError])

  // Delete
  let delConfig = {
    headers: {
      Action: "UBU",
      "Content-Type": "application/json",
    },
  }

  const handleClearData = () => {
    setIsSubmit(false)
    setDeleteModalOpen(false)
    setLockModalOpen(false)
    setUnlockModalOpen(false)
    setIsUpdate(false)
    setTimeout(() => {
      setIsSuccess(false)
      setSuccessMessages([""])
    }, 3000)
    setTimeout(() => {
      setIserror(false)
      setIserrorShow(false)
      setIsUnauhtError(false)
      setErrorMessages([])
    }, 10000)
  }

  const handleAppDelete = () => {
    setIsSubmit(true)
    const payload = {
      data: {
        usernameList: [
          {
            username: rowData.username,
          },
        ],
      },
    }
    api
      .delete("/users", payload, delConfig)
      .then((res) => {
        setIsUpdate(true)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setTimeout(() => {
          handleClearData()
        }, 3000)
      })
      .catch((error) => {
        setIsSuccess(false)
        setIserror(true)
        setDeleteModalOpen(false)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        handleClearData()
      })
  }

  // User Lock/Unlock
  const userLock = () => {
    setIsSubmit(true)
    api
      .put("/users/access-control/" + rowData.username + "/LOCK_USER")
      .then((res) => {
        setIsUpdate(true)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        handleClearData()
      })
      .catch((error) => {
        setIsSuccess(false)
        setIserror(true)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        handleClearData()
      })
  }
  const userUnlock = () => {
    setIsSubmit(true)
    api
      .put("/users/access-control/" + rowData.username + "/UNLOCK_USER")
      .then((res) => {
        setIsUpdate(true)
        setErrorMessages([])
        setIserror(false)
        setErrorMessages([])
        setIsUnauhtError(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        handleClearData()
      })
      .catch((error) => {
        setIsSuccess(false)
        setIserror(true)
        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
        handleClearData()
      })
  }

  const Cell = ({ cell, row }) => (
    <div>
      {cell.getValue() ? (
        <Tooltip placement="right-end" title="User Unlocked">
          <IconButton
            arrow
            onClick={() => {
              setLockModalOpen(true)
              setRowData(row.original)
            }}
          >
            <LockOpen color="success" />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip placement="right-end" title="User Locked">
          <IconButton
            arrow
            onClick={() => {
              setUnlockModalOpen(true)
              setRowData(row.original)
            }}
          >
            <Lock color="error" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  )

  let userSearchConfig = {
    headers: {
      Action: "SEARCH_APPR_USERS",
      "Search-Key": searchInput,
      "Sort-Order": "ASC",
      "Sort-Field": "userId",
    },
  }

  const handleSearch = () => {
    setIsLoading(true)
    api
      .get("/users/search", userSearchConfig)
      .then((res) => {
        setAppData(res.data?.dataList)
        setAppRowCount(res.data?.total)
        setIsLoading(false)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value)
  }

  const handleResetFilter = () => {
    fetchData()
    let filterValueElement = document.getElementById("filterValue")
    if (filterValueElement !== null) {
      filterValueElement.value = ""
    } else {
      console.log("Element with ID 'filterValue' not found.")
    }
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "username",
        header: "Username",
        
      },
      {
        accessorKey: "firstName",
        header: "First Name",
        
      },
      {
        accessorKey: "lastName",
        header: "Last Name",
        
      },
      {
        accessorKey: "primEmail",
        header: "Prim Email",
        
      },
      {
        accessorKey: "primContact",
        header: "Prim Contact",
        
      },
      {
        accessorKey: "userRole",
        header: "User Role",
        
      },
      {
        accessorKey: "accNonLocked",
        header: "Status",
        
        enableClick: true,
        Cell: Cell,
      },
    ],
    []
  )

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <div>
          <Alerts
            iserror={iserror}
            errorMessages={errorMessages}
            isSuccess={isSuccess}
            successMessages={successMessages}
            iserrorShow={iserrorShow}
          />
        </div>
        <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 400,
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Users"
              name="filterValue"
              inputProps={{ "aria-label": "search users" }}
              onChange={handleSearchChange}
            />
            <IconButton
              onClick={handleSearch}
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
          <Tooltip placement="right-end" title="Reset Filter">
            <Fab
              onClick={handleResetFilter}
              size="large"
              color="warning"
              variant="extended"
            >
              <RestartAltIcon />
            </Fab>
          </Tooltip>
        </Stack>
        <br />
        <Box sx={{ display: "grid" }}>
          <MaterialReactTable
            columns={columns}
            data={appData ?? []}
            state={{
              columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showProgressBars: isAppRefetching,
            }}
            getRowId={(row) => row.phoneNumber}
            initialState={{
              showColumnFilters: false,
              columnPinning: {
                left: ["mrt-row-actions"],
                right: ["accNonLocked"],
              },
            }}
            manualPagination
            muiToolbarAlertBannerProps={alertProps}
            onPaginationChange={setPagination}
            rowCount={appRowCount}
            muiTablePaginationProps={{
              rowsPerPageOptions: [10],
            }}
            enableSorting={false}
            editingMode="modal"
            enableColumnPinning
            enableRowActions
            enableEditing
            renderRowActions={({ row }) => (
              <Stack direction="row">
                <Tooltip arrow placement="left" title="Edit">
                  <IconButton
                    onClick={() => {
                      setUpdateModalOpen(true)
                      setRowData(row.original)
                    }}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="right" title="Delete">
                  <IconButton
                    color="error"
                    onClick={() => {
                      setDeleteModalOpen(true)
                      setRowData(row.original)
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}
          />
        </Box>
      </Box>
      <UpdateUserAccount
        rowData={rowData}
        open={updateModalOpen}
        setIsUpdate={setIsUpdate}
        onClose={() => {
          setUpdateModalOpen(false)
        }}
      />
      <DeleteModal
        open={deleteModalOpen}
        user={rowData.username}
        isSubmit={isSubmit}
        handleDelete={handleAppDelete}
        onClose={() => {
          setDeleteModalOpen(false)
        }}
      />
      <UserLockModal
        open={lockModalOpen}
        user={rowData.username}
        isSubmit={isSubmit}
        userLock={userLock}
        onClose={() => {
          setLockModalOpen(false)
        }}
      />
      <UserUnlockModel
        open={unlockModalOpen}
        user={rowData.username}
        isSubmit={isSubmit}
        userUnlock={userUnlock}
        onClose={() => {
          setUnlockModalOpen(false)
        }}
      />
    </div>
  )
}

export default ApproveTable
